import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAppStore } from '@runtime/core/store/appStore'
import { isAdminUserRole } from '@runtime/core/user/userRole'

type StudioAdminGuardProps = {
  children: ReactNode
}

export default function StudioAdminGuard({ children }: StudioAdminGuardProps) {
  const authToken = useAppStore(state => state.authToken)
  const user = useAppStore(state => state.user)

  if (authToken && !user) {
    return null
  }

  if (!isAdminUserRole(user?.role)) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
